import { Admin, Resource, nanoLightTheme} from 'react-admin';

// Sample CRUD components
import { UserList, UserEdit, UserCreate } from './accounts';
import createDataProvider from './dataProvider';
import { QuestionnaireList, QuestionnaireResponseList } from './questionnaires';
import { FindingList } from './findings';
import { AssignmentCreate, AssignmentEdit, AssignmentList, WebsiteList } from './assignments';
import { DRResponseList } from './dr_responses';
import { ActivityLogList } from './activity_logs';
import ResearchDashboard from './ResearchDashboard';


const AdminPage = () => {
  return (
    <Admin basename="/admin" dataProvider={createDataProvider()} theme={nanoLightTheme} dashboard={ResearchDashboard}>
      <Resource name="accounts" list={UserList} edit={UserEdit} create={UserCreate} />
      <Resource name="questionnaires" list={QuestionnaireList} />
      <Resource name="questionnaire/responses" list={QuestionnaireResponseList} />
      <Resource name="findings" list={FindingList} />
      <Resource name="websites" list={WebsiteList} />
      <Resource name="assignments" list={AssignmentList} edit={AssignmentEdit} create={AssignmentCreate} />
      <Resource name="dr-responses" list={DRResponseList} options={{ label: 'DR Quiz Responses' }} />
      <Resource name="activity-logs" list={ActivityLogList} options={{ label: 'Activity Logs' }} />
    </Admin>
  );
};

export default AdminPage;